import styled, { css } from 'styled-components'
import colors from 'utils/styling/colors'
import Flex from 'components/priority/Flex/Flex'
import Icon from 'components/priority/Icon/Icon'

export const SelectableCard = styled(Flex)(
  ({ maxWidth, maxHeight, cardPadding, isSelected, minHeight }) => css`
    ${maxWidth && `max-width: ${maxWidth};`}
    ${maxHeight && `max-height: ${maxHeight};`}
    ${minHeight && `min-height: ${minHeight};`}
    padding: ${cardPadding || '0px'};
    outline: ${isSelected ? '3px solid' : '1px solid'};
    outline-color: ${isSelected ? colors('brand') : colors('gray4')};
    border-radius: 4px;
    cursor: pointer;
  `,
)

//the user base is old, increase the size of clickable icons this is up from 14px
export const CardIcon = styled(Icon)`
  height: 18px;
  width: 18px;
  position: absolute;
  top: 8px;
  left: 8px;
`

export const CardTag = styled(Flex)`
  position: absolute;
  top: 8px;
  right: 8px;
  text-transform: uppercase;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.05rem;
  background: ${colors('secondary')};
  color: ${colors('white')};
  border-radius: 3px;
  padding: 0.15rem 0.4rem;
  z-index: 1;
`
